export enum LoadScriptTo {
  Head = "head",
  Body = "body",
}

export const loadScript = (
  { id, url, to }: { id: string; url: string; to: LoadScriptTo },
  callback?: () => void,
) => {
  const existingScript = !!document.getElementById(id);
  if (existingScript) {
    if (callback) callback();
    return;
  } else {
    const script = document.createElement("script");
    script.async = true;
    script.src = url;
    script.id = id;
    script.crossOrigin = "anonymous";
    document[to].appendChild(script);
    script.onload = () => {
      if (callback) callback();
    };
  }
};

export const loadFbPixelNolScript = (
  fbPixelScript: string,
  enterpriseName: string,
) => {
  const noscript = document.createElement("noscript");

  const img = document.createElement("img");
  img.height = 1;
  img.width = 1;
  img.style.display = "none";
  img.alt = enterpriseName;
  img.src = `https://www.facebook.com/tr?id=${fbPixelScript}&ev=PageView&noscript=1`;

  noscript.appendChild(img);

  document.body.appendChild(noscript);
};

export const loadFbPixelScript = (fbPixelId: string) => {
  // Validar que el Pixel ID sea válido
  if (!fbPixelId || typeof fbPixelId !== 'string' || fbPixelId.trim().length === 0) {
    console.error('❌ CATALOGUE: Pixel ID inválido:', fbPixelId);
    return;
  }
  
  // Verificar si ya existe un script con el mismo ID para evitar duplicados
  const existingScript = document.getElementById('facebook-pixel-script');
  if (existingScript) {
    console.log('⚠️ CATALOGUE: Script del pixel ya existe, reinicializando...');
    // Si ya existe fbq, solo reinicializamos con el nuevo ID
    if (typeof window.fbq === 'function') {
      window.fbq('init', fbPixelId);
      window.fbq('track', 'PageView');
      console.log('✅ CATALOGUE: Pixel reinicializado con ID:', fbPixelId);
    }
    return;
  }
  
  const script = document.createElement("script");
  script.id = "facebook-pixel-script";
  // ✅ CORRECCIÓN: Usar JSON.stringify para escape seguro del Pixel ID
  script.innerHTML =
    `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        console.log('=== 🔵 CATALOGUE: Script Pixel ejecutado ===');
        console.log('Pixel ID usado:', ${JSON.stringify(fbPixelId)});
        fbq('init', ${JSON.stringify(fbPixelId)});
        console.log('✅ CATALOGUE: Pixel inicializado en el script');
        fbq('track', 'PageView');
        console.log('✅ CATALOGUE: PageView trackeado desde script');
    `;

  // ✅ CORRECCIÓN: Agregar al HEAD en lugar de BODY
  document.head.appendChild(script);
  
  console.log('✅ CATALOGUE: Script agregado al HEAD del DOM');
  
  // Verificar después de un momento
  setTimeout(() => {
    console.log('=== 🔵 CATALOGUE: Verificando estado del Pixel ===');
    console.log('fbq disponible:', typeof window.fbq !== 'undefined');
    if (typeof window.fbq !== 'undefined') {
      console.log('fbq queue:', window.fbq?.queue);
      console.log('fbq loaded:', window.fbq?.loaded);
      
      // Verificar que el pixel se inicializó correctamente
      const initCalls = window.fbq?.q?.filter((q: any) => q && q[0] === 'init') || [];
      const pixelIds = initCalls.map((q: any) => q[1]);
      console.log('Pixel IDs inicializados:', pixelIds);
      
      if (!pixelIds.includes(fbPixelId)) {
        console.warn('⚠️ CATALOGUE: El Pixel ID no aparece en los IDs inicializados');
      }
    } else {
      console.error('❌ CATALOGUE: fbq NO está disponible después de 1 segundo');
    }
  }, 1000);
};
